/**
 * Consent categories for analytics and third-party integrations.
 *
 * `NECESSARY` is reserved for booking functionality and cannot be used by
 * analytics providers. Providers declare their required category; the loader
 * only loads them when the guest has granted that category.
 */
export const CONSENT_CATEGORIES = [
    'NECESSARY',
    'ANALYTICS',
    'MARKETING',
    'PERSONALIZATION',
];
export function isConsentGranted(state, category) {
    if (category === 'NECESSARY')
        return true;
    if (state === null)
        return false;
    switch (category) {
        case 'ANALYTICS':
            return state.analytics;
        case 'MARKETING':
            return state.marketing;
        case 'PERSONALIZATION':
            return state.personalization;
        default:
            return false;
    }
}
const CONSENT_STORAGE_KEY = 'ibe.consent';
export function readConsentState() {
    if (typeof window === 'undefined')
        return null;
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (raw === null)
        return null;
    try {
        const parsed = JSON.parse(raw);
        return {
            necessary: true,
            analytics: parsed.analytics,
            marketing: parsed.marketing,
            personalization: parsed.personalization,
            recordedAt: parsed.recordedAt,
        };
    }
    catch {
        return null;
    }
}
export function writeConsentState(state) {
    if (typeof window === 'undefined')
        return;
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify({
        necessary: true,
        analytics: state.analytics,
        marketing: state.marketing,
        personalization: state.personalization,
        recordedAt: new Date().toISOString(),
    }));
}
//# sourceMappingURL=consent.js.map